'use strict';
import register from './core';
import '../functions/jquery-global.js';

register('document-finder', function (element) {
  let wrapper = $(element);
  $('form', wrapper).submit(function (e) {
    $.ajax({
      type: 'POST',
      url: '/api/DocumentFinderApi/Find',
      type: this.method,
      data: $(this).serialize(),
      success: function (result) {
        var msg = $("<span></span>").attr('id', "epiLink").text("Följande dokument hittades: ");
        var a = $("<a></a>").attr('href', result.FileUrl).text(result.Name);
        
        $('#result').empty().append(msg, a);
      },
      error: function (xhr) {
        if (xhr.status === 400) {
          var err = $("<p></p>").text("Url kan inte vara tom!");
          $('#result').empty().append(err);
        }
        else if (xhr.status === 404) {
          var err = $("<p></p>").text("Hittade inget dokument med angiven url...");
          $('#result').empty().append(err);
        }
      }
    });
    e.preventDefault();
  });
});
